import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ParameterService} from "../../_services/parameter.service";
import {AssociationService} from "./services/association.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {isMoment} from "moment";

@Component({
    selector: 'app-association-edit',
    templateUrl: './association-edit.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssociationEditComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    unitBases: any = {};
    conditionTypes: any = {};
    integerLogics: any = {};

    association: any = {};

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private parameterService: ParameterService,
        private associationService: AssociationService,
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            id: [null, [Validators.required]],
            associationName: [null, [Validators.required]],
            email: [null, [Validators.required]],
            website: [null, [Validators.required]],
            phone: [null, [Validators.required]],
            address: [null, [Validators.required]],
            registeredOn: [null, [Validators.required]],
            status: [null, [Validators.required]],
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.conditionTypes = await this.parameterService.getParameterByName("CONDITION_TYPE");
        this.integerLogics = await this.parameterService.getParameterByName("INTEGER_LOGICAL_OPERATOR");
        this.unitBases = await this.parameterService.getParameterByName("UNIT_BASE");

        this.association = await this.associationService.getById(this.activatedRoute.snapshot.params.providerId);
        this.form.patchValue(this.association);
        this.form.controls.phone.setValue(this.association.phoneNo);
        this.form.controls.associationName.setValue(this.association.providerName);
        this.form.controls.id.setValue(this.association.id);
    }

    editAssociation() {
        const validation = this.check(this.form);
        if (validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Update Association",
                subMessage: "Are you sure want to update association?",
                buttonOkLabel: 'Yes, Update',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                if(isMoment(this.form.controls.registeredOn.value)) {
                    this.form.controls.registeredOn.setValue(this.date.momentToDbDate(this.form.controls.registeredOn.value));
                }

                this.associationService.update(this.form.value).then(r => {
                    this.showAlertDark('Association', 'Association has been updated successfully', '');
                    this.router.navigate(['/office/association/detail/' + this.association.id]).then();
                })
            }
        })
    }
}
